export const harmony = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Premium Nature Rubber.',
    'Patented Multi-functional Mounting Base & Adapters.',
    'Patented Rotating and Invisible Leveraged Balancing Structure. ',
    'Aerodynamic Profile Design for Clear Vision during High-speed Driving.',
  ],
  'material': [
    'Rubber: Premium Nature Rubber.',
    'Steel: SK5/SK6, Electrostatic Powder Coating.',
    'Rivet: Steel Rivet',
    'Plastic: Spacer & Adapter: POM, Spoiler: TPE',
    'Stainless Steel Backing: SUS304',
  ],
  'featureIcons': ["11", "02", "03", "04", "07", "10"],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "14", "mm": "350", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "15", "mm": "380", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "16", "mm": "400", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "17", "mm": "425", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "18", "mm": "450", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "19", "mm": "475", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "20", "mm": "500", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "21", "mm": "530", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "22", "mm": "560", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "23", "mm": "580", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "24", "mm": "600", "claw": "6", "width": "8", "thickness": "0.9" },
    { "inch": "26", "mm": "650", "claw": "6", "width": "8", "thickness": "0.9" },
    { "inch": "28", "mm": "700", "claw": "6", "width": "8", "thickness": "0.9" },
    { "inch": "30", "mm": "750", "claw": "6", "width": "9", "thickness": "0.9" },
    { "inch": "32", "mm": "800", "claw": "6", "width": "9", "thickness": "0.9" }
  ],
  'adapters': ['b1', 'b3', 'b6', 'bl-2a', 'p', 'pt-3', 'pt6', 'tl-2', 'tl4a', 'tlc', 'a3', 'ph-3', 'cl+cl-r', 'm4', 'm5', 'ml', 'pt-r', 'pl']
}
